module.exports = __webpack_public_path__ + "img/cancel_order.09b60b06.svg";